import { useT } from "../../../shared/i18n";
import { Badge, Card, ListItem } from "../../../shared/ui";

export interface OperationsSnapshot {
  telegram_state: string;
  incident_count: number;
  outbox_lag_seconds: number;
  active_jobs: number;
  release_version: string;
  correlation_id?: string | null;
}

/**
 * Operations shows service health only. It never surfaces reminder text,
 * Ability Record values, prompts, transcripts, tokens or payment secrets.
 */
export function OperationsPanel({
  snapshot,
}: {
  snapshot: OperationsSnapshot;
}) {
  const t = useT();
  const rows = [
    {
      id: "telegram",
      label: t("operations.telegram"),
      value: snapshot.telegram_state,
    },
    {
      id: "incidents",
      label: t("operations.incidents"),
      value: snapshot.incident_count,
    },
    {
      id: "outbox",
      label: t("operations.outboxLag"),
      value: `${String(snapshot.outbox_lag_seconds)}s`,
    },
    {
      id: "jobs",
      label: t("operations.activeJobs"),
      value: snapshot.active_jobs,
    },
    {
      id: "release",
      label: t("operations.release"),
      value: snapshot.release_version,
    },
  ];
  return (
    <section aria-label={t("operations.title")} className="flex flex-col gap-3">
      <h1 className="text-title text-fg">{t("operations.title")}</h1>
      <Card flush>
        <ul>
          {rows.map((row) => (
            <li key={row.id}>
              <ListItem
                primary={row.label}
                trailing={<span className="pr-4">{row.value}</span>}
              />
            </li>
          ))}
        </ul>
        {snapshot.correlation_id && (
          <p className="px-4 py-2 font-mono text-mono text-fg-subtle">
            {t("error.correlationId")}: {snapshot.correlation_id}
          </p>
        )}
        {snapshot.incident_count > 0 && (
          <Badge tone="warning" className="mx-4 mb-3">
            {snapshot.incident_count}
          </Badge>
        )}
      </Card>
    </section>
  );
}
